import React from 'react';
export default () => {
  return <h1 style={{ textAlign: 'center' }}>Invalid ID!!</h1>; 
};
